<template>
    <!-- Services section start -->
	<section id="services-section" class="px-12 lg:px-32 py-16 relative overflow-hidden">
        <!-- Text wrapper start -->
        <div class="flex gap-8 flex-col md:flex-row">
            <!-- Main text start -->
            <h1 class="uppercase text-5xl mb-4 font-semibold services-title">
                <strong>{{ $t('services.ourServices') }}</strong>
            </h1>
            <p class="xl:w-1/2 text-stone-500 mb-8 services-text text-justify">
                {{ $t('services.offer') }}
            </p>
            <!-- Main text end -->
        </div>
        <!-- Text wrapper end -->

        <!-- Services start -->
        <div class="flex flex-col md:flex-row md:gap-8">
            <!-- Wedding service start -->
            <div class="flex flex-row md:flex-col justify-between md:justify-start items-center md:items-start my-8 md:w-1/3">
                <img src="@/assets/services/engagement-rings.svg" alt="Wedding" class="-z-50 md:mb-4 wedding">
                <div class="w-2/3 text-right md:text-left md:w-full ">
                    <h1 class="text-2xl font-semibold">
                        {{ $t('services.marriage') }}
                    </h1> <br>
                    <p class="text-stone-500 text-justify">
                        {{ $t('services.marriageOffer') }}
                    </p>
                </div>
            </div>
            <!-- Wedding service end -->

            <!-- Service start -->
            <div class="flex flex-row md:flex-col justify-between md:justify-start items-center md:items-start my-8 md:w-1/3">
                <img src="@/assets/services/asylum.svg" alt="Asylum" class="-z-50 md:mb-4 asylum">
                <div class="w-2/3 text-right md:text-left md:w-full">
                    <h1 class="text-2xl font-semibold">
                        {{ $t('services.asylum') }}
                    </h1> <br>
                    <p class="text-stone-500 text-justify">
                        {{ $t('services.asylumOffer') }}
                    </p>
                </div>
            </div>
            <!-- Service end -->

            <!-- Service start -->
            <div class="flex flex-row md:flex-col justify-between md:justify-start items-center md:items-start my-8 md:w-1/3">
                <img src="@/assets/services/travel-permit.svg" alt="travel-permit" class="-z-50 md:mb-4 permit">
                <div class="w-2/3 text-right md:text-left md:w-full">
                    <h1 class="text-2xl font-semibold">
                        {{ $t('services.work') }}
                    </h1> <br>
                    <p class="text-stone-500 text-justify">
                        {{ $t('services.workOffer') }}
                    </p>
                </div>
            </div>
            <!-- Service end -->
             <!-- Service start -->
            <div class="flex flex-row md:flex-col justify-between md:justify-start items-center md:items-start my-8 md:w-1/3">
                <img src="@/assets/services/social-security.svg" alt="social-security" class="-z-50 md:mb-4 social">
                <div class="w-2/3 text-right md:text-left md:w-full">
                    <h1 class="text-2xl font-semibold">
                        {{ $t('services.socialSecurity') }}
                    </h1> <br>
                    <p class="text-stone-500 text-justify">
                        {{ $t('services.socialSecurityOffer') }}
                    </p>
                </div>
            </div>
            <!--Service end -->
        </div>
        <!-- Services end -->
        

        <!-- Circle start -->
        <div class="bg-[#132e63] h-64 w-64 rounded-full absolute top-0 -right-20 mt-16 -z-20 opacity-40"></div>
        <!-- Circle end -->
	</section>
	<!-- Services section end -->
    
    <section id="otherservices-section" class="px-12 lg:px-32 py-16 relative overflow-hidden">
        <!-- Text wrapper start -->
        <div class="flex gap-8 flex-col md:flex-row">
            <!-- Main text start -->
            <h1 class="text-5xl mb-4 font-semibold services-title">
               <strong>{{ $t('services.other') }}</strong>
            </h1>
            <!-- Main text end -->
        </div>
        <!-- Text wrapper end -->

        <!-- Other Services start -->
        <div class="flex flex-col md:flex-row md:gap-8">
            <!-- Service start -->
            <div class="flex flex-row md:flex-col justify-between md:justify-start items-center md:items-start my-8 md:w-1/3">
                <img src="@/assets/services/insurance.svg" alt="insurance" class="-z-50 md:mb-4 insurance">
                <div class="w-2/3 text-right md:text-left md:w-full">
                    <h1 class="text-2xl font-semibold">
                        {{ $t('services.insurance') }}
                    </h1> <br>
                    <p class="text-stone-500 text-justify">
                        {{ $t('services.insuranceOffer') }}
                    </p>
                </div>
            </div>
            <!-- Service end -->

            <!-- Service start -->
            <div class="flex flex-row md:flex-col justify-between md:justify-start items-center md:items-start my-8 md:w-1/3">
                <img src="@/assets/services/taxes.svg" alt="taxes" class="-z-50 md:mb-4 taxes">
                <div class="w-2/3 text-right md:text-left md:w-full">
                    <h1 class="text-2xl font-semibold">
                        {{ $t('services.taxes') }}
                    </h1> <br>
                    <p class="text-stone-500 text-justify">
                        {{ $t('services.taxesOffer') }}
                    </p>
                </div>
            </div>
            <!-- Service end -->

        </div>
        <!-- Other Services end -->
        

	</section>
</template>

<script>
export default {

}
</script>

<style>
#services-section {
    color:#051328 !important;
}
.services-title {
    color: #132e63; 
}
.services-text {
    color: #051328 !important; 
}

.wedding {
    width: 8rem;
}

.asylum {
    width: 8rem;
}

.permit {
    width: 8rem;
}

.social {
    width: 8rem;
}

.insurance {
    width: 8rem;
}

.taxes {
    width: 8rem;
}
</style>